<script>
  import { createEventDispatcher } from 'svelte';

  // Props
  export let label = '';           // Label for the select field (e.g., "Goal Scorer")
  export let options = [];          // Array of objects with name/label property
  export let selectedValue = null;  // Currently selected option
  export let actionType = '';       // The action type identifier

  const dispatch = createEventDispatcher();

  let isExpanded = !selectedValue; // Collapse if there's already a selection

  // Watch for changes to selectedValue to auto-collapse
  $: isExpanded = !selectedValue;

  function selectOption(option) {
    dispatch('select', { option, actionType });
  }

  function clearSelection() {
    isExpanded = true;
    dispatch('clear', { actionType });
  }

  function toggleExpanded() {
    if (selectedValue) {
      isExpanded = !isExpanded;
    }
  }
</script>

<div class="collapsible-select">
  <div class="select-header">
    <h4>{label}</h4>
    {#if selectedValue}
      <button
        class="contrast small selected-badge"
        on:click={clearSelection}
        type="button"
      >
        {selectedValue}
        <span class="remove-icon">×</span>
      </button>
    {/if}
  </div>

  {#if isExpanded}
    <div class="grid grid-2">
      {#each options as option}
        {@const isSelected = selectedValue === option.name}
        <button
          type="button"
          class="small mb-0"
          class:outline={!isSelected}
          class:contrast={isSelected}
          class:secondary={!isSelected}
          on:click={() => selectOption(option)}
        >
          {option.name}
        </button>
      {/each}
    </div>
  {/if}
</div>

<style>
  .collapsible-select {
    margin-bottom: 0rem;
  }

  .select-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0rem;
    gap: 1rem;
  }

  .select-header h4 {
    margin: 0;
    color: var(--pico-primary-text);
    font-size: 1.1rem;
    text-transform: capitalize;
    flex: 1;
  }

  .selected-badge {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    white-space: nowrap;
    margin: 0;
  }

  .remove-icon {
    font-size: 1.5rem;
    line-height: 1;
    font-weight: bold;
    margin-left: 0.25rem;
  }
</style>
